import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { InternalFieldName } from 'react-hook-form/dist/types/fields';
import Form from '../Crud/Form';

export interface ProductFormFields {
  name: string;
  price: number;
}

interface ProductFormProps {
  isLoading: boolean;
  title: string;
  formFields: ProductFormFields;
  formErrors: Record<string, any>;
  onSubmit: (data: any) => void;
}

function addServerErrors<T>(
  errors: { [P in keyof T]?: string[] },
  setError: any
) {
  return Object.keys(errors).forEach((key) => {
    setError(key as keyof T, {
      type: 'server',
      message: errors[key as keyof T]!.join('. '),
    });
  });
}

export default function ProductForm({
  isLoading,
  title,
  formFields,
  formErrors,
  onSubmit,
}: ProductFormProps) {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    reset,
  } = useForm<ProductFormFields>();

  useEffect(() => {
    reset(formFields);
  }, [formFields]);

  useEffect(() => {
    let shouldFocus = true;
    Object.keys(formErrors || {}).forEach((field: InternalFieldName) => {
      addServerErrors(formErrors, setError);

      shouldFocus = false;
    });
  }, [formErrors]);

  return (
    <Form isLoading={isLoading} title={title} onSubmitCallback={() => {}}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='mb-3'>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor='inputLabel' className='form-label'>
            Nome
          </label>
          <input
            {...register('name', { required: true })}
            className='form-control'
            placeholder='Nome'
            type='text'
            required
          />
          {errors.name && (
            <div className='form-text text-danger'>{errors.name.message}</div>
          )}
        </div>
        <div className='mb-3'>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor='inputLabel' className='form-label'>
            Preço
          </label>
          <input
            {...register('price', { required: true })}
            className='form-control'
            placeholder='Preço'
            type='number'
            min='.01'
            step='.01'
            required
          />
          {errors.price && (
            <div className='form-text text-danger'>{errors.price.message}</div>
          )}
        </div>
        <div className='d-flex justify-content-end gap-2'>
          <Link to='/products' className='btn btn-secondary'>
            Cancelar
          </Link>
          <button type='submit' className='btn btn-primary'>
            Salvar
          </button>
        </div>
      </form>
    </Form>
  );
}
